<template>
  <div class="carousel carousel-small">
    <VueSlickCarousel :arrows="true" :autoplay="true" :autoplaySpeed="10000">
      <div v-for="material in materials" :key="material.id" class="carousel--item">
        <localized-link :to="{name: 'Material', params: {
          lang: $i18n.locale,
          slug: decodeURIComponent(material.slug)
        }}">
          <div :style="{'background-image': `url(${material.featured_image})`}" class="carousel--item__content">
            <div class="content-top">
              <div class="categories" :style="{'background-color': handleBackgroundColorForProductCategory(material)}">
                <p v-html="material.categories.product_category.name" class="bold"></p>
                <p>
                  {{material.categories.material_type.name}}
                </p>
              </div>
              <div v-if="material.comment_competition_enabled" class="competition-icon-info">
                <img class="img-fluid icon-trophy filter-to-white"
                      src="@/assets/icons/trophy.svg"/>
                <span class="competition-icon-info--text">{{$t('contest.contestArticle')}}</span>
              </div>
            </div>
            <div class="content-bottom">
              <div class="title">
                <h3>
                  <span class="bold">{{material.post_title}}</span>
                </h3>
              </div>
              <div class="stats">
                <div v-if="dataType === 'rating' && material.stats && material.stats.average_rating" class="rating">
                  <img src="@/assets/icons/rating.svg"/>
                  <span class="data">{{material.stats.average_rating}}</span>
                  <span class="desc" v-html="$t('feed.averageRating')"></span>
                </div>
                <div v-if="dataType === 'visits' && material.stats.page_visits" class="views">
                  <img src="@/assets/icons/person-read.svg"/>
                  <span class="data">{{material.stats.page_visits}}</span>
                  <span class="desc" v-html="$t('feed.timesRead')"></span>
                </div>
                <div v-if="dataType === 'comments' && material.comment_count" class="comments">
                  <img src="@/assets/icons/comments.svg"/>
                  <span class="data">{{material.comment_count}}</span>
                  <span class="desc" v-html="$t('feed.articleComments')"></span>
                </div>
              </div>
            </div>
          </div>
        </localized-link>
      </div>
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  props: {
    materials: Array,
    dataType: String,
  },
  components: {
    VueSlickCarousel,
  },
  methods: {
    handleBackgroundColorForProductCategory(material) {
      let bgColor = '';
      if (material.categories?.product_category?.highlight_color) {
        bgColor = `${material.categories.product_category.highlight_color}cc`;
      } else {
        bgColor = '#00adefcc';
      }
      return bgColor;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.carousel {
  &--item {
    position: relative;
    &__content {
      background-size: cover;
      background-position: center center;
      position: relative;
      .categories {
        min-width: 33%;
        color: white;
        padding: .6rem 1.7rem;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        p {
          @extend .font-italic-custom;
          font-size: 14px;
          margin: 0;
          text-transform: uppercase;
        }
      }
      .title {
        @extend .bg-primary-opacity-80;
        height: 100%;
        h3 {
          word-break: break-word;
          margin-bottom: 0;
          color: white;
        }
      }
      .stats {
        @extend .bg-primary-opacity-80;
        display: flex;
        justify-content: space-around;
        > div {
          display: flex;
          align-items: center;
          color: white;
          &:not(:last-child) {
            margin-right: 1rem;
          }
          img {
            max-width: 40px;
            margin-right: .7rem;
          }
          .data {
            @extend .font-italic-custom;
            font-weight: bold;
            font-size: 1.55rem;
            margin-right: .5rem;
          }
          .desc {
            font-size: .7rem;
            line-height: 1.1em;
          }
        }
      }
      .competition-icon-info {
        display: flex;
        align-items: center;
        background: #b1332796;
        color: white;
        &--text {
          font-size: .7rem;
          line-height: 1.1em;
          display: inline-block;
          width: min-content;
          margin-left: 8px;
        }
        .icon-trophy {
          max-width: 26px;
          width: 26px;
        }
      }
    }
  }
  @include media-breakpoint-down(md) {
    &--item {
      &__content {
        .categories {
          padding: .8rem 1.6rem;
          p {
            font-size: 13px;
          }
        }
        .stats {
          img {
            max-width: 30px!important;
            width: 100%;
          }
          .data {
            font-size: 1.2rem!important;
          }
          .desc {
            font-size: .6rem!important;
          }
        }
      }
    }
  }
  @include media-breakpoint-down(sm) {
    &--item {
      &__content {
        .title {
          left: 0; bottom: 0; top: unset;
          min-height: 30%;
          height: unset;
          width: 50%;
          padding: 1rem 1.5rem;
          display: flex;
          align-items: center;
          h3 {
            width: 100%;
            font-size: 18px;
          }
        }
        .data-bottom {
          right: 0; left: unset;
          width: 50%;
          flex-direction: column;
        }
        .stats {
          flex-direction: column;
          > div:not(:last-child) {
            margin-bottom: .5rem;
          }
          > div {
            width: max-content;
          }
          img {
            max-width: 20px!important;
          }
        }
      }
    }
  }
  &.carousel-small {
    .carousel--item {
      .carousel--item__content {
        min-height: 400px;
        .title, .stats {
          position: static;
          background: unset;
          padding: 0;
          width: auto;
        }
        .title {
          margin-right: 1rem;
          h3 {
            font-size: 20px;
            width: auto;
          }
        }
        .content-top {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .categories {
            position: static;
          }
          .competition-icon-info {
            padding: 11px 15px;
          }
        }
        .content-bottom {
          @extend .bg-primary-opacity-80;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 1.5rem 1.3rem;
        }
        @include media-breakpoint-down(md) {
          min-height: 350px;
          .content-bottom {
            padding: 1.3rem 1.5rem;
          }
          .title {
            max-width: 70%;
            h3 {
              font-size: 20px!important;
            }
          }
          .stats {
            width: fit-content;
            > div {
              width: max-content;
            }
          }
        }
        @include media-breakpoint-down(sm) {
          .title {
            h3 {
              font-size: 16px!important;
            }
          }
        }
      }
    }
  }
}
::v-deep .slick-arrow {
  @extend .bg-primary-lighter-opacity-80;
  position: absolute;
  z-index: 2;
  width: 40px;
  height: 90px;
  &.slick-prev {
    left: 0;
    &::before {
      transform: rotate(180deg);
    }
  }
  &.slick-next {
    right: 0;
  }
  &::before {
    content: '';
    position: absolute;
    width: 50%;
    height: 70%;
    margin: auto;
    top: 0; left: 0; bottom: 0; right: 0;
    background-image: url('../assets/icons/arrow-thin.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
